import { useEffect } from "react";
import Footer from "../component/Footer";
import Header from "../component/Header";

const Terms = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <div className="px-5 md:px-0 md:mx-24 sm:mx-12">
        <div className="grid grid-cols-12 gap-5 mb-20 mt-20">
          {/* Main Content */}
          <div className="col-span-12 md:col-span-9 order-last md:order-first">
            <h3 className="font-bold text-[32px]" id="terms-and-conditions">
              TERMS & CONDITIONS
            </h3>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-3"
              style={{ lineHeight: "1.5" }}
            >
              Last Updated: May 6, 2025
            </p>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-6"
              style={{ lineHeight: "1.5" }}
            >
              Welcome to FastBetter.com. These Terms & Conditions ("Terms")
              govern your use of our websites, mobile apps, and related services
              ("Services"). By accessing or using our Services, you agree to be
              bound by these Terms.
            </p>

            <h3 className="font-bold text-[32px]" id="who-may-use-our-services">
              1. Who May Use Our Services
            </h3>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-3"
              style={{ lineHeight: "1.5" }}
            >
              You must be at least 18 years old and legally capable of entering
              into a contract to use our Services. By registering, you confirm
              that:
            </p>
            <ul className="list-disc pl-8 mb-6 text-base sm:text-lg 2xl:text-2xl">
              <li>You meet the age requirement</li>
              <li>
                You agree to use the Services in accordance with these Terms and
                applicable laws
              </li>
            </ul>

            <h3 className="font-bold text-[32px]" id="health-disclaimer">
              2. Health Disclaimer
            </h3>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-3"
              style={{ lineHeight: "1.5" }}
            >
              The Services provide wellness content such as yoga videos, fasting
              programs, and fitness tracking tools. We do not provide medical
              advice.
            </p>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-3"
              style={{ lineHeight: "1.5" }}
            >
              Always consult a healthcare professional before starting any
              fitness, nutrition, or fasting regimen. Use of our Services is at
              your own risk.
            </p>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-3"
              style={{ lineHeight: "1.5" }}
            >
              We disclaim liability for:
            </p>
            <ul className="list-disc pl-8 mb-6 text-base sm:text-lg 2xl:text-2xl">
              <li>Physical injury or health outcomes from following content</li>
              <li>Misuse of our plans or third-party advice</li>
            </ul>

            <h3 className="font-bold text-[32px]" id="account-registration">
              3. Account Registration
            </h3>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-3"
              style={{ lineHeight: "1.5" }}
            >
              You may need to register an account. You agree to:
            </p>
            <ul className="list-disc pl-8 mb-6 text-base sm:text-lg 2xl:text-2xl">
              <li>Provide accurate, complete information</li>
              <li>Keep your login credentials secure</li>
              <li>Be responsible for all activity under your account</li>
            </ul>

            <h3 className="font-bold text-[32px]" id="subscription-billing">
              4. Subscription & Billing
            </h3>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-3"
              style={{ lineHeight: "1.5" }}
            >
              Some features are accessible via a paid subscription, managed via:
            </p>
            <ul className="list-disc pl-8 mb-3 text-base sm:text-lg 2xl:text-2xl">
              <li>Apple App Store (iOS)</li>
              <li>Google Play Store (Android)</li>
              <li>Or directly via Stripe on our website</li>
            </ul>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-3">
              <strong>Subscription Terms:</strong>
            </p>
            <ul className="list-disc pl-8 mb-3 text-base sm:text-lg 2xl:text-2xl">
              <li>
                Billing is automatic at the selected plan interval
                (monthly/yearly)
              </li>
              <li>You are responsible for canceling before renewal</li>
              <li>No refunds for partial periods or unused time</li>
            </ul>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-3">To cancel:</p>
            <ul className="list-disc pl-8 mb-6 text-base sm:text-lg 2xl:text-2xl">
              <li>iOS: Go to Settings &gt; Apple ID &gt; Subscriptions</li>
              <li>Android: Google Play Store &gt; Payments & Subscriptions</li>
              <li>Web: Manage from your account settings</li>
            </ul>

            <h3 className="font-bold text-[32px]" id="free-trials">
              5. Free Trials & Promotional Offers
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              Unless otherwise stated, we do not currently offer free trials.
              Promotional pricing may be limited to the first billing cycle.
            </p>

            <h3 className="font-bold text-[32px]" id="intellectual-property">
              6. Intellectual Property
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-3">
              All content, logos, designs, and trademarks are owned by us or our
              licensors. You may not:
            </p>
            <ul className="list-disc pl-8 mb-6 text-base sm:text-lg 2xl:text-2xl">
              <li>Copy, modify, distribute, or resell our content</li>
              <li>
                Use our materials for commercial purposes without permission
              </li>
            </ul>

            <h3 className="font-bold text-[32px]" id="acceptable-use">
              7. Acceptable Use
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-3">
              You agree not to:
            </p>
            <ul className="list-disc pl-8 mb-3 text-base sm:text-lg 2xl:text-2xl">
              <li>Share your login with others</li>
              <li>Use bots, scrapers, or harmful scripts</li>
              <li>Upload or transmit malicious content</li>
              <li>Misrepresent your identity or medical condition</li>
            </ul>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              Violation may result in account termination without refund.
            </p>

            <h3 className="font-bold text-[32px]" id="termination">
              8. Termination
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              We may suspend or terminate your access if you violate these
              Terms. You may delete your account at any time, but no refund will
              be given for prepaid periods.
            </p>

            <h3 className="font-bold text-[32px]" id="limitation-of-liability">
              9. Limitation of Liability
            </h3>
            <ul className="list-disc pl-8 mb-6 text-base sm:text-lg 2xl:text-2xl">
              <li>
                We disclaim all warranties (fitness for a particular purpose,
                non-infringement, etc.)
              </li>
              <li>
                We are not liable for indirect, incidental, or consequential
                damages
              </li>
              <li>
                Our total liability will not exceed the amount paid for the
                Services in the last 12 months
              </li>
            </ul>

            <h3 className="font-bold text-[32px]" id="data-privacy">
              10. Data & Privacy
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              Use of our Services is also governed by our
              <a
                href="https://www.fastbetter.com/privacy"
                className="underline ml-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              , which explains how we collect, use, and protect your data.
            </p>

            <h3 className="font-bold text-[32px]" id="third-party-services">
              11. Third-Party Services
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-3">
              Our apps may use or integrate with:
            </p>
            <ul className="list-disc pl-8 mb-3 text-base sm:text-lg 2xl:text-2xl">
              <li>Apple HealthKit</li>
              <li>Google Fit</li>
              <li>Firebase Analytics</li>
              <li>Stripe, Apple Pay, or Google Pay</li>
            </ul>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              Your data with these services is governed by their respective
              privacy policies.
            </p>

            <h3 className="font-bold text-[32px]" id="governing-law">
              12. Governing Law
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              These Terms are governed by the laws of Cyprus and the European
              Union (GDPR, eCommerce Directive). Disputes shall be handled under
              Cypriot jurisdiction.
            </p>

            <h3 className="font-bold text-[32px]" id="changes-to-terms">
              13. Changes to These Terms
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              We may update these Terms. Continued use after changes constitutes
              acceptance. Users will be notified via email or in-app banner.
            </p>

            <h3 className="font-bold text-[32px]" id="contact">
              14. Contact
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-3">
              For support or legal questions:
            </p>
            <ul className="list-disc pl-8 text-base sm:text-lg 2xl:text-2xl">
              <li>
                Support:{" "}
                <a href="mailto:support@fastbetter.com" className="underline">
                  support@fastbetter.com
                </a>
              </li>
              <li>
                Legal:{" "}
                <a href="mailto:legal@fastbetter.com" className="underline">
                  legal@fastbetter.com
                </a>
              </li>
            </ul>
          </div>

          {/* Sidebar */}
          <div className="col-span-12 md:col-span-3 md:sticky top-24 min-h-fit md:h-[475px] bg-orgltbg rounded-3xl">
            <div className="px-5 py-4 md:px-6 md:py-8">
              <ol className="space-y-2 pl-4">
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#terms-and-conditions" className="hover:underline">
                    Terms & Conditions
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a
                    href="#who-may-use-our-services"
                    className="hover:underline"
                  >
                    1. Who May Use Our Services
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#health-disclaimer" className="hover:underline">
                    2. Health Disclaimer
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#account-registration" className="hover:underline">
                    3. Account Registration
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#subscription-billing" className="hover:underline">
                    4. Subscription & Billing
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#free-trials" className="hover:underline">
                    5. Free Trials & Promotional Offers
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#intellectual-property" className="hover:underline">
                    6. Intellectual Property
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#acceptable-use" className="hover:underline">
                    7. Acceptable Use
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#termination" className="hover:underline">
                    8. Termination
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a
                    href="#limitation-of-liability"
                    className="hover:underline"
                  >
                    9. Limitation of Liability
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#data-privacy" className="hover:underline">
                    10. Data & Privacy
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#third-party-services" className="hover:underline">
                    11. Third-Party Services
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#governing-law" className="hover:underline">
                    12. Governing Law
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#changes-to-terms" className="hover:underline">
                    13. Changes to These Terms
                  </a>
                </li>
                <li className="mb-3" style={{ lineHeight: "1.5" }}>
                  <a href="#contact" className="hover:underline">
                    14. Contact
                  </a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
